/**
 * Tech Branch Configurations - defines the 6 major tech branches plus special branches
 */

import type { TechBranch } from './TechTypes';

export interface BranchConfig {
  id: TechBranch;
  name: string;
  description: string;
  color: string;
  icon: string;
  shortName: string;
}

export const TECH_BRANCHES: Record<TechBranch, BranchConfig> = {
  bingfa: {
    id: 'bingfa',
    name: '兵法',
    description: '战争艺术与军事战略，提升军队战斗力',
    color: '#c62828',
    icon: 'sword',
    shortName: '兵',
  },
  baigong: {
    id: 'baigong',
    name: '百工',
    description: '工匠技艺与武器装备，提升生产效率',
    color: '#795548',
    icon: 'anvil',
    shortName: '工',
  },
  nonggeng: {
    id: 'nonggeng',
    name: '农耕',
    description: '农业发展与粮食生产，提升经济基础',
    color: '#388e3c',
    icon: 'wheat',
    shortName: '农',
  },
  shangdao: {
    id: 'shangdao',
    name: '商道',
    description: '商业贸易与财政管理，提升金币收入',
    color: '#ffc107',
    icon: 'coin',
    shortName: '商',
  },
  moxue: {
    id: 'moxue',
    name: '墨学',
    description: '墨家机关术与防御工程，提升城防能力',
    color: '#757575',
    icon: 'gear',
    shortName: '墨',
  },
  yinyang: {
    id: 'yinyang',
    name: '阴阳',
    description: '道家术法与神秘力量，提升法术效果',
    color: '#7b1fa2',
    icon: 'yinyang',
    shortName: '阴',
  },
  faction: {
    id: 'faction',
    name: '势力',
    description: '势力专属科技，每个国家独有',
    color: '#1565c0',
    icon: 'flag',
    shortName: '专',
  },
  ultimate: {
    id: 'ultimate',
    name: '天命',
    description: '至高科技，天子令',
    color: '#d4af37',
    icon: 'dragon',
    shortName: '天',
  },
};

// Branch display order for UI
export const BRANCH_ORDER: TechBranch[] = [
  'bingfa',
  'baigong',
  'nonggeng',
  'shangdao',
  'moxue',
  'yinyang',
  'faction',
  'ultimate',
];

// Get branch by ID
export function getBranchConfig(branch: TechBranch): BranchConfig {
  return TECH_BRANCHES[branch];
}

// Get branch color
export function getBranchColor(branch: TechBranch): string {
  return TECH_BRANCHES[branch].color;
}

// Get branch name
export function getBranchName(branch: TechBranch): string {
  return TECH_BRANCHES[branch].name;
}

// Branch tier layout configuration
export interface TierLayout {
  yStart: number;    // Starting Y position for this tier
  ySpacing: number;  // Spacing between techs in this tier
  xSpacing: number;  // Horizontal spacing between techs
}

export const TIER_LAYOUTS: Record<number, TierLayout> = {
  1: { yStart: 10, ySpacing: 15, xSpacing: 20 },
  2: { yStart: 25, ySpacing: 15, xSpacing: 20 },
  3: { yStart: 45, ySpacing: 15, xSpacing: 25 },
  4: { yStart: 65, ySpacing: 15, xSpacing: 25 },
  5: { yStart: 85, ySpacing: 15, xSpacing: 30 },
};

// Status colors for tech nodes
export const STATUS_COLORS = {
  completed: '#d4af37',     // Gold
  researching: '#2196f3',   // Blue
  available: '#ffffff',     // White
  locked: '#616161',        // Gray
  excluded: '#c62828',      // Red
};

// Connection line styles
export const CONNECTION_STYLES = {
  normal: {
    color: '#9e9e9e',
    width: 2,
    dash: [],
  },
  alternative: {
    color: '#9e9e9e',
    width: 2,
    dash: [5, 5],
  },
  exclusion: {
    color: '#c62828',
    width: 2,
    dash: [],
  },
};
